/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDashyKpiRecapTemplateConfig } from '../../models/api-response-dashy-kpi-recap-template-config';

export interface GetDashyKpiRecapTemplateConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getDashyKpiRecapTemplateConfig(http: HttpClient, rootUrl: string, params: GetDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>> {
  const rb = new RequestBuilder(rootUrl, getDashyKpiRecapTemplateConfig.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>;
    })
  );
}

getDashyKpiRecapTemplateConfig.PATH = '/v1/api/admin-ui/dashy-kpi-recap-template';
